import React, { ComponentPropsWithRef } from 'react'
import { useCommonCtx } from '../context/useCommonCtx'
import { useTranslation } from '../i18n/useTranslation'
import type { TypographyVariant } from '../types/mui'
import { MTypo } from '../components/MTypo/MTypo'

interface Props extends ComponentPropsWithRef<'div'> {
    currentRound: number
    titleV: TypographyVariant
    bodyV: TypographyVariant
    hasConfirmRound: boolean
}
export const AwardRound = (p: Props) => {
    const { className, currentRound, titleV, bodyV, hasConfirmRound, ...rest } =
        p
    const t = useTranslation(useCommonCtx())
    let title,
        body = ''
    if (currentRound === 1) {
        title = t('award1_title')
        body = t('award1_body')
    } else if (currentRound === 2) {
        title = t('award2_title')
        body = t('award2_body')
    } else if (currentRound === 3) {
        title = t('award3_title')
        body = t('award3_body')
    }

    return (
        <div className="flex flex-1 flex-col justify-center items-center">
            <MTypo
                variant={titleV}
                textClassName="text-center"
                outerClassName="mb-12"
            >
                {title}
            </MTypo>
            {hasConfirmRound && (
                <MTypo variant={bodyV} className="text-justify">
                    {body}
                </MTypo>
            )}
        </div>
    )
}
